<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="membershipProgramData === null"
        >Create Membership Program</span
      >
      <span v-else>Update Membership Program</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <a-tabs default-active-key="membership-program-info">
          <!-- Start of Membership Program Info -->
          <a-tab-pane key="membership-program-info" tab="Info">
            <div class="row">
              <div class="col">
                <base-input label="Name" required>
                  <a-input
                    v-model.trim="$v.formData.name.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.formData.name.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.name.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Description">
                  <a-textarea
                    v-model="formData.description"
                    :auto-size="{ minRows: 3, maxRows: 3 }"
                    :disabled="viewMode"
                  />
                </base-input>
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col">
                <label><h4>Default Configurations</h4></label>
                <a-tabs default-active-key="userRegistrationDefaults">
                  <a-tab-pane
                    key="userRegistrationDefaults"
                    tab="Default Registration"
                    :forceRender="true"
                  >
                    <div class="row">
                      <div class="col">
                        <base-input label="Status">
                          <a-select
                            v-model="formData.status"
                            :disabled="viewMode"
                          >
                            <a-select-option value="A">
                              Active
                            </a-select-option>
                            <a-select-option value="I">
                              Inactive
                            </a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <base-input label="Default Membership Level">
                          <a-select
                            v-model="formData.default_membership_level_id"
                            :disabled="viewMode"
                          >
                            <a-select-option
                              v-for="membership_level in membershipLevels"
                              :key="membership_level.id"
                              :value="membership_level.id"
                            >
                              {{ membership_level.name }}
                            </a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <base-input label="Default Quick Registration Status">
                          <a-select
                            v-model="formData.default_quick_member_status_id"
                            :disabled="viewMode"
                          >
                            <a-select-option
                              v-for="memberStatus in memberStatuses"
                              :key="memberStatus.id"
                              :value="memberStatus.id"
                            >
                              {{ memberStatus.name }}
                            </a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <base-input label="Default Add Member Status">
                          <a-select
                            v-model="formData.default_member_status_id"
                            :disabled="viewMode"
                          >
                            <a-select-option
                              v-for="memberStatus in memberStatuses"
                              :key="memberStatus.id"
                              :value="memberStatus.id"
                            >
                              {{ memberStatus.name }}
                            </a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>
                  </a-tab-pane>
                  <a-tab-pane
                    key="memberRegistrationDefaults"
                    tab="Member Registration"
                    :forceRender="true"
                  >
                    <div class="row">
                      <div class="col">
                        <base-input>
                          <label class="form-control-label"
                            >Self Registration
                            <a-tooltip placement="right">
                              <template slot="title">
                                <span
                                  >Default membership configuration for members
                                  who will sign up through web or mobile.</span
                                >
                              </template>
                              <small>
                                <i
                                  class="fa fa-info-circle"
                                  aria-hidden="true"
                                /> </small></a-tooltip
                          ></label>
                        </base-input>
                        <base-input label="Default Membership Level">
                          <a-select
                            v-model="
                              formData.member_registration_settings.default
                                .membership_level
                            "
                            :disabled="viewMode"
                          >
                            <a-select-option
                              v-for="membership_level in membershipLevels"
                              :key="membership_level.id"
                              :value="membership_level.id"
                            >
                              {{ membership_level.name }}
                            </a-select-option>
                          </a-select>
                        </base-input>
                        <base-input label="Default Member Status">
                          <a-select
                            v-model="
                              formData.member_registration_settings.default
                                .status
                            "
                            :disabled="viewMode"
                          >
                            <a-select-option
                              v-for="memberStatus in memberStatuses"
                              :key="memberStatus.id"
                              :value="memberStatus.id"
                            >
                              {{ memberStatus.name }}
                            </a-select-option>
                          </a-select>
                        </base-input>
                      </div>
                    </div>
                  </a-tab-pane>
                </a-tabs>
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col">
                <base-input label="Member Number From" required>
                  <a-input
                    v-model.trim="$v.formData.member_number_from.$model"
                    :disabled="viewMode || membershipProgramData !== null"
                  />
                  <div
                    v-if="$v.formData.member_number_from.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.member_number_from.required"
                    >
                      Field is required
                    </div>

                    <div
                      class="error"
                      v-if="!$v.formData.member_number_from.maxLength"
                    >
                      Maximum of ({{
                        $v.formData.member_number_from.$params.maxLength.max
                      }}) character is allowed
                    </div>

                    <div
                      class="error"
                      v-if="!$v.formData.member_number_from.numeric"
                    >
                      Value must be numeric
                    </div>

                    <div
                      class="error"
                      v-if="
                        !$v.formData.member_number_from
                          .validateMemberNumberFrom &&
                        $v.formData.member_number_from.required
                      "
                    >
                      Value must not be greater than member number to
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Member Number To" required>
                  <a-input
                    v-model.trim="$v.formData.member_number_to.$model"
                    :disabled="viewMode || membershipProgramData !== null"
                  />
                  <div
                    v-if="$v.formData.member_number_to.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.member_number_to.required"
                    >
                      Field is required
                    </div>

                    <div
                      class="error"
                      v-else-if="!$v.formData.member_number_to.maxLength"
                    >
                      Maximum of ({{
                        $v.formData.member_number_to.$params.maxLength.max
                      }}) character is allowed
                    </div>

                    <div
                      class="error"
                      v-else-if="!$v.formData.member_number_to.numeric"
                    >
                      Value must be numeric
                    </div>

                    <div
                      class="error"
                      v-else-if="
                        !$v.formData.member_number_to.validateMemberNumberTo
                      "
                    >
                      Value must not be lesser than member number from
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Prefix">
                  <a-input
                    v-model="formData.prefix"
                    :disabled="viewMode || membershipProgramData !== null"
                  />
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input>
                  <b-form-checkbox
                    v-model="expirePointsWithCard"
                    name="check-button_n"
                    switch
                    :disabled="viewMode"
                  >
                    <label class="form-control-label"
                      >Expire Points With Card</label
                    >
                  </b-form-checkbox>
                </base-input>
              </div>
            </div>

            <!-- <div class="row" v-if="!expirePointsWithCard">
              <div class="col">
                <base-input label="Points Grace Period Start" required>
                  <a-input
                    v-model.trim="
                      $v.formData.date_points_grace_period_start.$model
                    "
                    placeholder="MM/DD"
                    :disabled="viewMode"
                  />
                  <div
                    v-if="$v.formData.date_points_grace_period_start.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="
                        !$v.formData.date_points_grace_period_start.required
                      "
                    >
                      Field is required
                    </div>

                    <div
                      class="error"
                      v-else-if="
                        !$v.formData.date_points_grace_period_start
                          .monthDayFormat
                      "
                    >
                      Use MM/DD date format.
                    </div>
                  </div>
                </base-input>
              </div>
              <div class="col">
                <base-input label="Points Expiry" required>
                  <a-input
                    v-model.trim="$v.formData.date_points_expiry.$model"
                    placeholder="MM/DD"
                    :disabled="viewMode"
                  />
                  <div
                    v-if="$v.formData.date_points_expiry.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.date_points_expiry.required"
                    >
                      Field is required
                    </div>

                    <div
                      class="error"
                      v-else-if="!$v.formData.date_points_expiry.monthDayFormat"
                    >
                      Use MM/DD date format.
                    </div>
                  </div>
                </base-input>
              </div>
            </div> -->

            <div class="row d-none">
              <div class="col">
                <base-input label="SMS Notification Sending Time">
                  <a-time-picker
                    use12-hours
                    format="h:mm a"
                    @change="smsTimeOnChange"
                    :value="
                      formData.unregistered_member_sms_notification_time !==
                      null
                        ? moment(
                            formData.unregistered_member_sms_notification_time,
                            'hh:mm A'
                          )
                        : null
                    "
                    :disabled="viewMode"
                    style="width: 100%"
                  />
                </base-input>
              </div>
            </div>
          </a-tab-pane>
          <!-- End of Membership Program Info -->

          <!-- Start of Expiry -->
          <a-tab-pane key="expiry" tab="Expiry" :forceRender="true">
            <MembershipProgramExpiryTab
              ref="expiryConfigTab"
              :expiryConfigData="expiryConfigData"
              :membershipSettingsData="formData.membership_settings"
              :viewMode="viewMode"
            />
          </a-tab-pane>
          <!-- End of Expiry -->
          <!-- Start of Notification -->
          <a-tab-pane
            key="notification"
            tab="Points Notification"
            :forceRender="true"
          >
            <MembershipProgramNotificationTab
              ref="notificationConfigTab"
              :notificationConfigData="notificationConfigData"
              :viewMode="viewMode"
            />
          </a-tab-pane>
          <!-- End of Notification -->

          <!-- Start of Mandatory Fields -->
          <!-- <a-tab-pane key="mandatory-fields" tab="Mandatory Fields">
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.first_name"
                  v-model="memberFields.first_name"
                  disabled
                >
                  First Name</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.last_name"
                  v-model="memberFields.last_name"
                  disabled
                >
                  Last Name</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.mobile_no"
                  v-model="memberFields.mobile_no"
                  disabled
                >
                  Mobile Number</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.middle_name"
                  v-model="memberFields.middle_name"
                  :disabled="viewMode"
                >
                  Middle Name</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.allow_null_mobile_no"
                  v-model="memberFields.allow_null_mobile_no"
                  :disabled="viewMode"
                >
                  Enable Nullable Mobile Number</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.nick_name"
                  v-model="memberFields.nick_name"
                  :disabled="viewMode"
                >
                  Nickname</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.last_name_suffix"
                  v-model="memberFields.last_name_suffix"
                  :disabled="viewMode"
                >
                  Last Name Suffix</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.email"
                  v-model="memberFields.email"
                  :disabled="viewMode"
                >
                  Email</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.gender"
                  v-model="memberFields.gender"
                  :disabled="viewMode"
                >
                  Gender</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.customer_type"
                  v-model="memberFields.customer_type"
                >
                  Customer Type</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.birth_month"
                  v-model="memberFields.birth_month"
                  :disabled="viewMode"
                >
                  Birthday (MM)</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.birth_day"
                  v-model="memberFields.birth_day"
                  :disabled="viewMode"
                >
                  Birthday (DD)</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.birth_year"
                  v-model="memberFields.birth_year"
                  :disabled="viewMode"
                >
                  Birthday (YYYY)</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.zipcode"
                  v-model="memberFields.zipcode"
                  :disabled="viewMode"
                >
                  Location - Zipcode</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.location_region"
                  v-model="memberFields.location_region"
                  :disabled="viewMode"
                >
                  Location - Region</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.location_province"
                  v-model="memberFields.location_province"
                  :disabled="viewMode"
                >
                  Location - Province</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.location_city"
                  v-model="memberFields.location_city"
                  :disabled="viewMode"
                >
                  Location - City</a-checkbox
                >
              </div>
            </div>

            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.location_barangay"
                  v-model="memberFields.location_barangay"
                  :disabled="viewMode"
                >
                  Location - Barangay</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.location_street"
                  v-model="memberFields.location_street"
                  :disabled="viewMode"
                >
                  Location - street</a-checkbox
                >
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-checkbox
                  :value="memberFields.location_unit"
                  v-model="memberFields.location_unit"
                  :disabled="viewMode"
                >
                  Location - Unit</a-checkbox
                >
              </div>
            </div>
          </a-tab-pane> -->
          <!-- End of Mandatory Fields -->

          <!-- Start of Mailer Config -->
          <a-tab-pane key="mailer-config" tab="Mailer">
            <div class="row">
              <div class="col">
                <base-input label="Service" required>
                  <a-input
                    v-model.trim="$v.mailer.service.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.mailer.service.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.mailer.service.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Email" required>
                  <a-input
                    v-model.trim="$v.mailer.email.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.mailer.email.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.mailer.email.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Password" required>
                  <a-input-password
                    v-model.trim="$v.mailer.password.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.mailer.password.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.mailer.password.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Sender Name" required>
                  <a-input
                    v-model.trim="$v.mailer.sender.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.mailer.sender.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.mailer.sender.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>
          </a-tab-pane>
          <!-- End of Mailer Config -->

          <!-- Start of Settings -->
          <!-- <a-tab-pane key="setings" tab="Settings"> -->
          <!-- <div class="row">
              <div class="col">
                <base-input>
                  <b-form-checkbox
                    v-model="smsOtpItemRedemptionFlag"
                    name="check-button"
                    switch
                    :disabled="viewMode"
                  >
                    <label class="form-control-label"
                      >Generate OTP for Item Redemption</label
                    >
                  </b-form-checkbox>
                </base-input>
              </div>
            </div> -->

          <!-- Account Specfic Settings -->
          <!-- <div v-if="dynamic_form.length > 0">
              <dynamic-form
                :convertedJson="{ mode: 'cards', groups: dynamic_form }"
                :disabled="viewMode"
                :formSettings="membershipProgramMeta"
                @valueUpdated="updateSettings"
                :key="dynamicFormKey"
              ></dynamic-form>
            </div> -->
          <!-- Account Specfic Sttings -->
          <!-- </a-tab-pane> -->
          <!-- End of Settings -->

          <!-- Start of Membership Card -->
          <!-- <a-tab-pane key="membership-card" tab="Membership Card"> -->
          <!-- <div class="row">
              <div class="col">
                <base-input>
                  <b-form-checkbox
                    v-model="membershipCardGeneration"
                    name="check-button"
                    switch
                    :disabled="viewMode"
                  >
                    <label class="form-control-label"
                      >Enable Membership Card</label
                    >
                  </b-form-checkbox>
                </base-input>
              </div>
            </div> -->

          <!-- <div class="row" v-if="membershipCardGeneration">
              <div class="col">
                <label class="form-control-label"
                  >Card Expiry <span class="text-danger">*</span></label
                >
              </div>
            </div> -->

          <!-- Year duration only -->
          <!-- <div class="row" v-if="membershipCardGeneration">
              <div class="col-6">
                <div
                  v-if="
                    membershipCardGeneration &&
                    !formData.membership_card_settings.month_year_options
                  "
                >
                  <base-input required>
                    <a-select
                      v-model="
                        formData.membership_card_settings.card_expiry
                          .year_duration
                      "
                      :disabled="viewMode"
                    >
                      <a-select-option
                        v-for="duration in options.yearDurations"
                        :key="duration.year"
                        :value="duration.year"
                      >
                        {{ duration.value }}
                      </a-select-option>
                    </a-select>
                    <small
                      ><strong><i>Year Duration</i></strong></small
                    >
                    <div
                      v-if="
                        $v.formData.membership_card_settings.card_expiry
                          .year_duration.$dirty
                      "
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.membership_card_settings.card_expiry
                            .year_duration.required
                        "
                      >
                        Field is required
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
            </div> -->

          <!-- Enable month/year options -->
          <!-- <div class="row">
              <div class="col-6">
                <div
                  v-if="
                    membershipCardGeneration &&
                    formData.membership_card_settings.month_year_options
                  "
                >
                  <base-input required>
                    <a-select
                      v-model="
                        formData.membership_card_settings.card_expiry.month_date
                      "
                      :disabled="viewMode"
                    >
                      <a-select-option
                        v-for="month in options.months"
                        :key="month.key"
                        :value="month.key"
                      >
                        {{ month.name }}
                      </a-select-option>
                    </a-select>
                    <small
                      ><strong><i>Month</i></strong></small
                    >

                    <div
                      v-if="
                        $v.formData.membership_card_settings.card_expiry
                          .month_date.$dirty
                      "
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.membership_card_settings.card_expiry
                            .month_date.required
                        "
                      >
                        Field is required
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>

              <div class="col-6">
                <div
                  v-if="
                    membershipCardGeneration &&
                    formData.membership_card_settings.month_year_options
                  "
                >
                  <base-input required>
                    <a-select
                      v-model="
                        formData.membership_card_settings.card_expiry.year_date
                      "
                      :disabled="viewMode"
                    >
                      <a-select-option
                        v-for="year in options.years"
                        :key="year"
                        :value="year"
                      >
                        {{ year }}
                      </a-select-option>
                    </a-select>
                    <small
                      ><strong><i>Year</i></strong></small
                    >
                    <div
                      v-if="
                        $v.formData.membership_card_settings.card_expiry
                          .year_date.$dirty
                      "
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.membership_card_settings.card_expiry
                            .year_date.required
                        "
                      >
                        Field is required
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
            </div> -->

          <!-- <div class="row" v-if="membershipCardGeneration">
              <div class="col">
                <a-checkbox
                  :value="formData.membership_card_settings.month_year_options"
                  v-model="formData.membership_card_settings.month_year_options"
                >
                  <strong
                    ><i>Enable month and year options</i></strong
                  ></a-checkbox
                >
              </div>
            </div> -->
          <!-- </a-tab-pane> -->
          <!-- End of Membership Card -->

          <!-- Start of OTP -->
          <a-tab-pane tab="OTP" :forceRender="true">
            <MembershipProgramOtpTab
              ref="otpConfigTab"
              :otpConfigData="otpConfigData"
              :viewMode="viewMode"
            />
          </a-tab-pane>
          <!-- End of OTP -->
        </a-tabs>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer()"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="membershipProgramData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createMembershipProgram"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="confirmUpdate"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required, maxLength, numeric } from 'vuelidate/lib/validators';
// import DynamicForm from '../DynamicForm.vue';
import moment from 'moment';
import CryptoJS from 'crypto-js';

import MembershipProgramExpiryTab from '@/components/MembershipProgram/Tabs/ExpiryTab.vue';
import MembershipProgramNotificationTab from '@/components/MembershipProgram/Tabs/NotificationTab.vue';
import MembershipProgramOtpTab from '@/components/MembershipProgram/Tabs/OtpTab.vue';

import axios from 'axios';
import secureStorage from '@/controllers/secureStorage';

const ENC_SECRET = process.env.VUE_APP_ENC_SECRET;
const S3Api = process.env.VUE_APP_BXI_S3_API;

const validateMemberNumberTo = function (memberNumberTo) {
  const memberNumberFrom = this.formData.member_number_from;
  return memberNumberTo >= memberNumberFrom ? true : false;
};

const validateMemberNumberFrom = function (memberNumberFrom) {
  const memberNumberTo = this.formData.member_number_to;
  return memberNumberFrom <= memberNumberTo ? true : false;
};

export default {
  name: 'MembershipProgramForm',
  props: {
    membershipProgramData: Object,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  components: {
    // DynamicForm,
    MembershipProgramExpiryTab,
    MembershipProgramNotificationTab,
    MembershipProgramOtpTab
  },
  data() {
    return {
      formSubmitting: false,
      currentYear: moment().year(),
      hasCustomFieldError: false,
      formData: {
        name: null,
        description: null,
        dynamic_form: [],
        membershipProgramMeta: {},
        default_membership_level_id: null,
        status: 'A',
        default_member_status_id: null,
        default_quick_member_status_id: null,
        card_number_from: null,
        card_number_to: null,
        card_number_generation_flag: false,
        member_number_from: null,
        member_number_to: null,
        prefix: null,
        date_points_grace_period_start: null,
        date_points_expiry: null,
        mandatory_customer_fields: null,
        unregistered_member_sms_notification_time: null,
        membership_card_generation_flag: false,
        expire_points_with_card_flag: false,
        member_registration_settings: {
          default: {
            membership_level: null,
            status: null
          }
        },
        // membership_card_settings: {
        //   month_year_options: false,
        //   card_expiry: {
        //     year_duration: null,
        //     month_date: null,
        //     year_date: null
        //   }
        // },
        membership_settings: null
      },
      mailer: {
        service: 'gmail',
        email: null,
        password: null,
        sender: null
      },
      settings: {
        sms_otp_item_redemption: false
      },
      notificationConfigData: null,
      expiryConfigData: null,
      membershipLevels: [],
      memberStatuses: [],
      memberFields: {
        customer_type: false,
        first_name: true,
        last_name: true,
        mobile_no: true,
        allow_null_mobile_no: false,
        email: false,
        gender: false,
        birth_month: false,
        birth_day: false,
        birth_year: false,
        location_region: false,
        location_city: false,
        location_barangay: false,
        location_street: false,
        location_unit: false,
        nick_name: false,
        middle_name: false,
        last_name_suffix: false,
        location_province: false,
        membership_number: false,
        zipcode: false
      },
      options: {
        yearDurations: [
          { year: 1, value: '1 Year' },
          { year: 2, value: '2 Years' },
          { year: 3, value: '3 Years' },
          { year: 4, value: '4 Years' },
          { year: 5, value: '5 Years' }
        ],
        years: [],
        months: [
          { key: '01', name: 'January' },
          { key: '02', name: 'Febuary' },
          { key: '03', name: 'March ' },
          { key: '04', name: 'April ' },
          { key: '05', name: 'May ' },
          { key: '06', name: 'June' },
          { key: '07', name: 'July ' },
          { key: '08', name: 'August ' },
          { key: '09', name: 'September' },
          { key: '10', name: 'October' },
          { key: '11', name: 'November' },
          { key: '12', name: 'December' }
        ]
      }
    };
  },
  validations: {
    formData: {
      name: { required },
      member_number_from: {
        required,
        maxLength: maxLength(16),
        numeric,
        validateMemberNumberFrom
      },
      member_number_to: {
        required,
        maxLength: maxLength(16),
        numeric,
        validateMemberNumberTo
      }

      // membership_card_settings: {
      //   card_expiry: {
      //     year_duration: {
      //       required: requiredIf(function () {
      //         return (
      //           this.membershipCardGeneration &&
      //           !this.formData.membership_card_settings.month_year_options
      //         );
      //       })
      //     },
      //     month_date: {
      //       required: requiredIf(function () {
      //         return (
      //           this.membershipCardGeneration &&
      //           this.formData.membership_card_settings.month_year_options
      //         );
      //       })
      //     },
      //     year_date: {
      //       required: requiredIf(function () {
      //         return (
      //           this.membershipCardGeneration &&
      //           this.formData.membership_card_settings.month_year_options
      //         );
      //       })
      //     }
      //   }
      // }
    },
    mailer: {
      service: { required },
      email: { required },
      password: { required },
      sender: { required }
    }
  },
  methods: {
    moment,

    updateSettings(newFormSettings, settingsGrouping, errors) {
      console.log(newFormSettings);
      this.formData.meta = newFormSettings;
      console.log(settingsGrouping);
      console.log(errors);
      // this.setFormData(this.formData);

      if (errors.length > 0) {
        this.hasCustomFieldError = true;
      } else {
        this.hasCustomFieldError = false;
      }
    },

    smsTimeOnChange(time, timeString) {
      this.formData.unregistered_member_sms_notification_time = timeString;
    },
    async getMembershipLevels(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/membership_levels`
      );
      this.membershipLevels = data.sort((a, b) => a.name.localeCompare(b.name));
    },

    async getMemberStatuses(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/member_statuses`
      );
      this.memberStatuses = data.sort((a, b) => a.name.localeCompare(b.name));
    },

    async createMembershipProgram() {
      this.$v.formData.$touch();
      this.$v.mailer.$touch();
      this.$refs.expiryConfigTab.$v.formData.$touch();
      this.$refs.notificationConfigTab.$v.formData.$touch();
      this.$refs.otpConfigTab.$v.formData.$touch();

      if (
        !this.$v.formData.$invalid &&
        !this.$v.mailer.$invalid &&
        !this.hasCustomFieldError &&
        !this.$refs.expiryConfigTab.$v.formData.$invalid &&
        !this.$refs.notificationConfigTab.$v.formData.$invalid &&
        !this.$refs.otpConfigTab.$v.formData.$invalid
      ) {
        this.formSubmitting = true;
        if (
          this.$refs.notificationConfigTab.formData.pointsEarning &&
          this.$refs.notificationConfigTab.formData.pointsEarningConfig.image
        ) {
          let url = await this.s3Upload(
            this.$refs.notificationConfigTab.formData.pointsEarningConfig.image
          );
          if (url) {
            this.$refs.notificationConfigTab.formData.pointsEarningConfig.image_url =
              url;
          }
        }
        if (
          this.$refs.notificationConfigTab.formData.pointsRedemption &&
          this.$refs.notificationConfigTab.formData.pointsRedemptionConfig.image
        ) {
          let url = await this.s3Upload(
            this.$refs.notificationConfigTab.formData.pointsRedemptionConfig
              .image
          );
          if (url) {
            this.$refs.notificationConfigTab.formData.pointsRedemptionConfig.image_url =
              url;
          }
        }
        let fields = JSON.stringify(this.memberFields);
        this.formData.mandatory_customer_fields = fields;

        this.formData.membership_settings =
          this.$refs.expiryConfigTab.membershipSettings;

        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_membership_programs/v2',
          {
            membership_program: this.formData,
            mailer: this.mailer,
            settings: this.settings,
            expiryConfig: this.$refs.expiryConfigTab.formData,
            notificationConfig: this.$refs.notificationConfigTab.formData,
            otpConfig: this.$refs.otpConfigTab.formData
          }
        );

        if (response.message === 'Success') {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error,
              placement: 'topLeft'
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.',
              placement: 'topLeft'
            });
          }
        }
        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },

    async editMembershipProgram() {
      this.$v.formData.$touch();
      this.$v.mailer.$touch();
      this.$refs.notificationConfigTab.$v.formData.$touch();
      this.$refs.expiryConfigTab.$v.formData.$touch();
      this.$refs.otpConfigTab.$v.formData.$touch();

      if (
        !this.$v.formData.$invalid &&
        !this.$v.mailer.$invalid &&
        !this.hasCustomFieldError &&
        !this.$refs.notificationConfigTab.$v.formData.$invalid &&
        !this.$refs.expiryConfigTab.$v.formData.$invalid &&
        !this.$refs.otpConfigTab.$v.formData.$invalid
      ) {
        this.formSubmitting = true;
        if (
          this.$refs.notificationConfigTab.formData.pointsEarning &&
          this.$refs.notificationConfigTab.formData.pointsEarningConfig.image
        ) {
          let url = await this.s3Upload(
            this.$refs.notificationConfigTab.formData.pointsEarningConfig.image
          );
          if (url) {
            this.$refs.notificationConfigTab.formData.pointsEarningConfig.image_url =
              url;
          }
        }
        if (
          this.$refs.notificationConfigTab.formData.pointsRedemption &&
          this.$refs.notificationConfigTab.formData.pointsRedemptionConfig.image
        ) {
          let url = await this.s3Upload(
            this.$refs.notificationConfigTab.formData.pointsRedemptionConfig
              .image
          );
          if (url) {
            this.$refs.notificationConfigTab.formData.pointsRedemptionConfig.image_url =
              url;
          }
        }

        let fields = JSON.stringify(this.memberFields);
        this.formData.mandatory_customer_fields = fields;

        if (this.formData.expire_points_with_card_flag === true) {
          this.formData.date_points_grace_period_start = null;
          this.formData.date_points_expiry = null;
        }

        this.formData.membership_settings =
          this.$refs.expiryConfigTab.membershipSettings;

        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_membership_programs/v2/' + this.membershipProgramData.id,
          {
            membership_program: this.formData,
            mailer: this.mailer,
            settings: this.settings,
            notificationConfig: this.$refs.notificationConfigTab.formData,
            expiryConfig: this.$refs.expiryConfigTab.formData,
            otpConfig: this.$refs.otpConfigTab.formData
          }
        );

        if (response.message === 'Success') {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error,
              placement: 'topLeft'
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.',
              placement: 'topLeft'
            });
          }
        }
        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },

    async s3Upload(file = []) {
      if (file && file.length > 0 && file[0] instanceof File) {
        console.log('Uploading to S3', file);
        const formData = new FormData();
        formData.append('file', file[0]);
        let filePath = null;
        try {
          const upload = await axios({
            method: 'POST',
            url:
              S3Api +
              '?account_name=' +
              this.accountName +
              '&profile=app-notification-images',
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem('uploadToken')
            },
            data: formData
          });

          if (typeof upload.data.path !== 'undefined' && upload.data.path) {
            console.log('File uploaded');
            filePath = upload.data.path;
          } else {
            console.log('No upload path');
            this.$message.error('Unable to upload image. Please try again!');
          }

          return filePath;
        } catch (err) {
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },

    createYearsOptions() {
      let years = [];
      for (let i = 1; i <= 5; i++) {
        years.push(this.currentYear + i);
      }

      this.options.years = years;
    },

    confirmUpdate() {
      this.$confirm({
        title: 'Confirm',
        content: 'Are you sure you want to commit the changes you made?',
        onOk: () => {
          this.editMembershipProgram();
        }
      });
    },

    closeDrawer() {
      this.$refs.expiryConfigTab.clearForm();
      this.clearForm();
      this.clearFormOptions();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
      this.$v.mailer.$reset();

      this.$refs.notificationConfigTab.clearForm();
      this.$refs.otpConfigTab.clearForm();
    },

    clearFormOptions() {
      this.membershipLevels = [];
      this.memberStatuses = [];
    },

    clearForm() {
      this.formData = {
        name: null,
        description: null,
        default_membership_level_id: null,
        status: 'A',
        card_number_from: null,
        card_number_to: null,
        card_number_generation_flag: false,
        member_number_from: null,
        member_number_to: null,
        prefix: null,
        date_points_grace_period_start: null,
        date_points_expiry: null,
        mandatory_customer_fields: null,
        unregistered_member_sms_notification_time: null,
        membership_card_generation_flag: false,
        expire_points_with_card_flag: false,
        member_registration_settings: {
          default: { membership_level: null, status: null }
        },
        membership_card_settings: {
          month_year_options: false,
          card_expiry: {
            year_duration: null,
            month_date: null,
            year_date: null
          }
        }
      };

      this.memberFields = {
        first_name: true,
        last_name: true,
        mobile_no: true,
        allow_null_mobile_no: false,
        email: false,
        gender: false,
        birth_month: false,
        birth_day: false,
        birth_year: false,
        location_region: false,
        location_city: false,
        location_barangay: false,
        location_street: false,
        location_unit: false,
        nick_name: false,
        middle_name: false,
        last_name_suffix: false,
        location_province: false,
        membership_number: false,
        zipcode: false
      };

      this.mailer = {
        service: 'gmail',
        email: null,
        password: null,
        sender: null
      };

      this.expiryConfigData = null;
      this.notificationConfigData = null;
    },

    setFormData(data = null) {
      if (data !== null) {
        const {
          name,
          description,
          default_membership_level_id,
          status,
          default_member_status_id,
          default_quick_member_status_id,
          card_number_from,
          card_number_to,
          member_number_from,
          member_number_to,
          card_number_generation_flag,
          prefix,
          date_points_grace_period_start,
          date_points_expiry,
          mailerConfig,
          smsOtpItemRedemptionSetting,
          meta,
          expiryConfig,
          otpConfig,
          notificationSetting,
          member_registration_settings,
          membership_settings
        } = data;

        let {
          membership_card_generation_flag,
          expire_points_with_card_flag,
          mandatory_customer_fields
        } = data;

        this.getMembershipLevels(data.id);
        this.getMemberStatuses(data.id);

        let unregistered_member_sms_notification_time =
          data.unregistered_member_sms_notification_time !== null
            ? moment(
                data.unregistered_member_sms_notification_time,
                'HH:mm:ss'
              ).format('hh:mm A')
            : null;

        if (mandatory_customer_fields) {
          this.memberFields = JSON.parse(mandatory_customer_fields);
        } else {
          this.memberFields = {
            first_name: true,
            last_name: true,
            mobile_no: true,
            allow_null_mobile_no: false,
            email: false,
            gender: false,
            birth_month: false,
            birth_day: false,
            birth_year: false,
            location_region: false,
            location_city: false,
            location_barangay: false,
            location_street: false,
            location_unit: false,
            nick_name: false,
            middle_name: false,
            last_name_suffix: false,
            location_province: false,
            membership_number: false,
            zipcode: false
          };
        }

        let memberRegistrationSettings = {
          default: { membership_level: null, status: null }
        };
        if (member_registration_settings != null) {
          memberRegistrationSettings = member_registration_settings;
        }
        this.formData = {
          name,
          description,
          default_membership_level_id,
          status,
          default_member_status_id,
          default_quick_member_status_id,
          card_number_from,
          card_number_to,
          member_number_from,
          member_number_to,
          card_number_generation_flag,
          prefix,
          date_points_grace_period_start,
          date_points_expiry,
          unregistered_member_sms_notification_time,
          membership_card_generation_flag,
          expire_points_with_card_flag,
          meta,
          member_registration_settings: memberRegistrationSettings,
          membership_settings
        };

        this.membershipProgramMeta =
          typeof this.membershipProgramData?.meta !== 'undefined'
            ? JSON.parse(this.membershipProgramData.meta)
            : {};

        if (mailerConfig.length > 0) {
          let _mailerConfig = JSON.parse(mailerConfig[0].extras);

          this.mailer = {
            service: _mailerConfig.service,
            email: _mailerConfig.email,
            sender: _mailerConfig.sender,
            password: CryptoJS.AES.decrypt(
              _mailerConfig.password,
              ENC_SECRET
            ).toString(CryptoJS.enc.Utf8)
          };
        } else {
          this.mailer = {
            service: 'gmail',
            email: null,
            sender: null,
            password: null
          };
        }

        if (
          typeof otpConfig !== 'undefined' &&
          otpConfig &&
          Object.keys(otpConfig).length > 0
        ) {
          const _otpConfig = JSON.parse(otpConfig.extras);

          this.otpConfigData = {
            duration: {
              length: _otpConfig.duration.length,
              unit: _otpConfig.duration.unit
            },
            refresh: {
              interval: _otpConfig.refresh.interval,
              unit: _otpConfig.refresh.unit
            }
          };
        } else {
          this.otpConfigData = {
            duration: {
              length: 5,
              unit: 'minutes'
            },
            refresh: {
              interval: '60',
              unit: 'seconds'
            }
          };
        }

        if (typeof expiryConfig !== 'undefined' && expiryConfig) {
          this.expiryConfigData = JSON.parse(expiryConfig.extras);
        }
        if (
          typeof notificationSetting !== 'undefined' &&
          notificationSetting.length > 0
        ) {
          this.notificationConfigData = JSON.parse(
            notificationSetting[0].extras
          );
        }

        this.formData.expire_points_with_card_flag =
          expire_points_with_card_flag;
        if (smsOtpItemRedemptionSetting.length > 0) {
          this.settings.sms_otp_item_redemption = Boolean(
            parseInt(smsOtpItemRedemptionSetting[0].value)
          );
        } else {
          this.settings.sms_otp_item_redemption = false;
        }
      } else {
        this.clearForm();
      }
    }
  },
  async created() {
    // Check if there are custom fields or dynamic form
    const response = await HTTPRequest.getRequest(
      '/api/v1/clp_account_custom_settings'
    );

    console.log('-------------!!!!------------');
    console.log(response);

    if (response.error) {
      console.log('Not available');
      this.dynamic_form = [];
    } else {
      console.log('Should render');
      this.dynamic_form = JSON.parse(response.dynamic_form);
      this.dynamicFormKey++;
    }

    this.setFormData(this.membershipProgramData);
    this.createYearsOptions();
  },
  watch: {
    membershipProgramData: function (data) {
      this.setFormData(data);
    },
    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      }
    }
  },
  computed: {
    generationFlag: {
      get() {
        return this.formData.card_number_generation_flag ? true : false;
      },
      set(val) {
        this.$v.formData.card_number_from.$reset();
        this.$v.formData.card_number_to.$reset();
        this.formData.card_number_generation_flag = val;
      }
    },

    smsOtpItemRedemptionFlag: {
      get() {
        return this.settings.sms_otp_item_redemption ? true : false;
      },
      set(val) {
        this.settings.sms_otp_item_redemption = val;
      }
    },
    expirePointsWithCard: {
      get() {
        return this.formData.expire_points_with_card_flag;
      },
      set(val) {
        this.formData.expire_points_with_card_flag = val;
      }
    },
    membershipCardGeneration: {
      get() {
        return this.formData.membership_card_generation_flag ? true : false;
      },
      set(val) {
        this.formData.membership_card_generation_flag = val;
      }
    },

    sampleMemberNumber: function () {
      return this.formData.member_number_from;
    },
    accountName() {
      return this.$store.getters.getAccount?.account_name ?? null;
    }
  }
};
</script>

<style scoped></style>
